import {Spinner, TitlePage} from "../../shared";
import React, {useEffect, useMemo, useState} from "react";
import {useSelector} from "react-redux";
import group from "../../group";
import app from "../index";
import GroupPost from "../../shared/groupPost/groupPost";
import users from "../../users";
import {Helmet} from "react-helmet";
import icon from "../../../images/pageIcon.png";
import {useIntl} from "react-intl";
import {Link, useNavigate} from "react-router-dom";
import ContinueWatchingRow from "../../cap17drive/squadflixHome/rows/ContinueWatchingRow";

import '../../cap17drive/squadflixHome/squadflix-home-options/squadflix-home-options.scss';
import logo from "../../../images/logos/squadDiskHR.png";

function HomeFeed() {

    const intl = useIntl();

    const groupPosts = useSelector(app.selectors.getGroupPosts);
    const postsPerPage = 8;
    const [postsPage, setPostsPage] = useState(1);
    const [files, setFiles] = useState(null);
    const userGroups = useSelector(group.selectors.userGroups);
    const darkMode = useSelector(users.selectors.isDarkMode);
    const navigate = useNavigate();

    const loadingGroups = useMemo(() => {
        return userGroups == null;
    }, [userGroups]);

    const loading = useMemo(() => {
        return loadingGroups;
    }, [loadingGroups]);

    const feedIsEmpty = useMemo(() => {
        return files?.length === 0 && !loadingGroups
    }, [files, loadingGroups]);

    useEffect(() => {
        const fileLists = Object.values(groupPosts);
        const aux = [].concat(...fileLists);
        aux.sort((a, b) => b.dateTimestamp - a.dateTimestamp);
        setFiles(aux);
    }, [groupPosts]);

    const handleScroll = (e) => {
        const visorElement = document.getElementById('visor');
        if (visorElement && files) {
            const rect = visorElement.getBoundingClientRect();
            if (postsPage * postsPerPage <= files.length) {
                if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                    setPostsPage(prevValue => prevValue + 1);
                }
            }
        }
    };

    useEffect(() => {
        const scrollContainer = document.getElementById('home__scrollContainer');
        scrollContainer.removeEventListener('scroll', handleScroll);
        scrollContainer.addEventListener('scroll', handleScroll);
        return () => {
            scrollContainer.removeEventListener('scroll', handleScroll);
        };
    }, [files?.length]);

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>SquadDisk | {intl.formatMessage({id: "app.home"})}</title>
                <link rel="icon" href={icon}/>
            </Helmet>
            <TitlePage
                className="mb-4"
                disableScroll
                leftClass="col-12"
                title={<div
                    className="d-flex flex-row justify-content-center align-items-center w-100 cap17drive-header__title fs-4">
                    <div className="d-flex flex-row align-items-center gap-4">
                        <div>
                            <img src={logo} height="30px" className="App-logo" alt="logo"
                                 style={{filter: darkMode ? "brightness(1000%)" : "brightness(30%)"}}/>
                        </div>
                    </div>
                </div>} icon={undefined} rightOptions={undefined} titleClass={undefined} rightClass={undefined}
                hideSeparator={true} fixedHeight={undefined} style={undefined}/>
            <div className="pt-3">
                <ContinueWatchingRow
                    intl={intl}
                    customTitle={<>Continua viendo en <Link className="link-body-emphasis" to="/squadflix">
                        <i className="fa-solid fa-clapperboard"></i> SquadFlix
                    </Link></>}/>

                <div className="squadflix-home-options">
                    <button className="squadflix-home-options__option"
                            onClick={() => navigate('/squadflix')}>
                        SquadFlix <i className="fa-solid fa-clapperboard"></i>
                    </button>
                    <button className="squadflix-home-options__option" onClick={() => navigate('/squadflix/live')}>
                        En vivo <i className="fa-solid fa-tower-broadcast"></i>
                    </button>
                </div>

                {!feedIsEmpty && files?.length > 0 && <div id="postsContainer">
                    {files.slice(0, postsPerPage * postsPage).map(file => {
                        const group = userGroups.groups.find(x => x.id === file.groupId)
                        if (!group) return null;
                        return <GroupPost key={file.file.id + file.dateTimestamp} post={file}
                                          group={group}
                                          canDeletePost={false} fromGroup={false}
                                          tags={group.tags ?? []}/>
                    })}
                </div>}
                {loading &&
                    <div className="d-flex flex-row justify-content-center mt-5">
                        <Spinner/>
                    </div>}
                {feedIsEmpty && !loadingGroups &&
                    <div className="d-flex flex-wrap text-center mt-5 justify-content-center">
                        <h3 className="col-12">{intl.formatMessage({id: "app.no-posts.title"})}</h3>
                        <span className="col-12">
                            {intl.formatMessage({id: "app.no-posts.description"})}
                        </span>
                    </div>}
                <div id="visor" className="mb-4"></div>
            </div>
        </div>
    )
}

export default HomeFeed;
